export default {
    /**
     * Inserts separator symbol for Philippine mobile number digits
     * to make it readable.
     *
     * This separates the country code and mobile network prefix
     * Example: +63 929 556 8582
     * @param {String} mobile 13 digits
     * @param {String} separator symbol used to separate the digits
     * @returns digits with separator
     */
    splitMobileNumber(mobile, separator = " ") {
        if (!mobile) return;
        let formatted = mobile.replace(/[^0-9]+/gi, "").split("");
        for (let counter = 0; counter < [2, 5, 9].length; counter++)
            formatted.splice([2, 5, 9][counter] + counter, 0, separator);
        return "+" + formatted.join("");
    },
    /**
     * Concatenates unit and plural ending to a word
     * @param {Number} value
     * @param {String} word
     * @param {String} plural
     * @return formatted word
     */
    formatToPlural(value, word, plural = "s") {
        let wordStr = value;
        if (value) wordStr += word;
        if (value > 1) wordStr += plural;
        return wordStr;
    },

    /**
     * Trim String based on params word length
     * Add "..." at the end
     * @param {String} value
     * @param {String} wordLength
     * @return formatted word
     */
    trimString(str = "", wordLength = 6) {
        if (!str) return;
        const strLength = str.split(" ");
        if (strLength.length > wordLength) {
            return (
                strLength.filter((f, key) => key < wordLength).join(" ") + "..."
            );
        }
        return strLength.join(" ");
    },
};
